import { Trans, useTranslation } from 'react-i18next';
import TicketIcon from '@/assets/icons/airTicket-icon.svg?react';
import HotelIcon from '@/assets/icons/hotel-icon.svg?react';
import RouteIcon from '@/assets/icons/route-icon.svg?react';
import AirplaneIcon from '@/assets/icons/airplane-icon.svg?react';
import styles from './WhatIncluded.module.scss';

interface IProps {
    isAloyPlan?: boolean;
}

const WhatIncluded = ({ isAloyPlan = false }: IProps) => {
    const { t } = useTranslation();

    const stepsFlykube = [
        {
            image: <TicketIcon style={{ width: 88, aspectRatio: '88 / 79' }} />,
            name: t('includedItemTitle1'),
            description: t('includedItemDescription1'),
        },
        {
            image: <HotelIcon style={{ width: 85, aspectRatio: '1 / 1' }} />,
            name: t('includedItemTitle2'),
            description: t('includedItemDescription2'),
        },
        {
            image: <RouteIcon style={{ width: 85, aspectRatio: '1 / 1' }} />,
            name: t('includedItemTitle3'),
            description: t('includedItemDescription3'),
        },
        {
            image: <AirplaneIcon style={{ width: 78, aspectRatio: '1 / 1' }} />,
            name: t('includedItemTitle4'),
            description: t('includedItemTitle4'),
        },
    ];

    const stepsAloy = [
        {
            number: 1,
            image: <TicketIcon style={{ width: 88, aspectRatio: '88 / 79' }} />,
            name: t('getStarted'),
            description: t('chooseDestinationAndDates'),
        },
        {
            number: 2,
            image: <HotelIcon style={{ width: 85, aspectRatio: '1 / 1' }} />,
            name: t('howItWorksTitle2'),
            description: t('adjustTripFilters'),
        },
        {
            number: 3,
            image: <AirplaneIcon style={{ width: 78, aspectRatio: '1 / 1' }} />,
            name: t('bookAndTravel'),
            description: t('reserveYourVacation'),
        },
    ];

    const steps = isAloyPlan ? stepsAloy : stepsFlykube;

    return (
        <section className={styles.innerContainer}>
            <h2 className={styles.sectionTitle}>{isAloyPlan ? <AloyTitle /> : <FlyKubeTitle />}</h2>
            <div className={`${styles.itemsContainer} ${isAloyPlan && styles.aloy}`}>
                {steps.map((step) => (
                    <div key={step.name} className={styles.itemContainer}>
                        {step.image}
                        <h3 className={styles.itemTitle}>{step.name}</h3>
                        <p>{step.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

const FlyKubeTitle = () => (
    <Trans i18nKey="whatIsIncludedTitle">
        <span>What&apos;s </span>
        <span className={styles.colouredSpan}>included?</span>
    </Trans>
);

const AloyTitle = () => (
    <Trans i18nKey="howItWorksCustom">
        How <span className={styles.colouredSpan}>it works</span>
    </Trans>
);
export default WhatIncluded;
